import component from './PhSuitcaseSimple.vue_vue_type_script_lang.vue.js';
export { default } from './PhSuitcaseSimple.vue_vue_type_script_lang.vue.js';
import { render } from './PhSuitcaseSimple.vue_vue_type_template_id_15717dbb_lang.vue.js';

component.render = render;
